// extracted by mini-css-extract-plugin
export var alert = "Duplicate-module--alert--1651f";
export var button = "Duplicate-module--button--3329e";
export var footer = "Duplicate-module--footer--aebd4";
export var iconButton = "Duplicate-module--iconButton--8a93b";